import React from 'react'
import {Space} from "antd";

const StatItem = ({
    heading,
    subHeading
                  })=>{

    return (
        <Space>
            <div className={'font-xxxl bold'}>
            {
                heading
            }
            </div>
            <div style={{maxWidth:90}}>
                {subHeading}
            </div>

        </Space>
    )
}

export default StatItem